var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "collapse",
    { attrs: { title: "Análisis y verificación de costo" } },
    [
      !_vm.isReadOnly
        ? _c("validation-provider", {
            attrs: {
              "custom-messages": {
                required: "El campo es requerido."
              },
              rules: "required"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-text-area", {
                        attrs: {
                          "count-classes": ["d-block", "small-counter"],
                          "custom-error-msg": errors[0],
                          error: errors[0],
                          label:
                            "Análisis y resultado que justifique la razonabilidad del costo de conformidad a lo establecido en el Manual para la negociación de servicios profesionales adquiridos mediante fondos administrados por la Secretaría Auxiliar de Asuntos Federales.",
                          maxlength: 3000,
                          "show-char-count": ""
                        },
                        model: {
                          value: _vm.model.costAnalysis,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "costAnalysis", $$v)
                          },
                          expression: "model.costAnalysis"
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              390388422
            )
          })
        : _vm.isReadOnly
        ? _c("div", { staticClass: "my-2 data-label" }, [
            _c("label", { staticClass: "data-label" }, [
              _vm._v(
                " Análisis y resultado que justifique la razonabilidad del costo de conformidad a lo establecido en el Manual para la negociación de servicios profesionales adquiridos mediante fondos administrados por la Secretaría Auxiliar de Asuntos Federales. "
              )
            ]),
            _vm._v(" " + _vm._s(_vm._f("empty")(_vm.model.costAnalysis)) + " ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }